import AdminLayout from "@/components/layout/AdminLayout";
import { Card } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { Button } from "@/components/ui/button";
import { useState } from "react";
import { toast } from "sonner";

export default function AdminSettings() {
  const [maint, setMaint] = useState(false);
  const [signups, setSignups] = useState(true);

  return (
    <AdminLayout>
      <div className="space-y-6 max-w-3xl">
        <div>
          <div className="text-xs uppercase tracking-widest text-primary font-semibold">Settings</div>
          <h1 className="font-display text-3xl mt-2">Platform settings</h1>
        </div>
        <Card className="p-6 space-y-6">
          <div className="flex items-center justify-between">
            <div><Label>Maintenance mode</Label><div className="text-xs text-muted-foreground">Show a banner and disable new applications</div></div>
            <Switch checked={maint} onCheckedChange={(v) => { setMaint(v); toast.success("Preference saved"); }} />
          </div>
          <div className="flex items-center justify-between">
            <div><Label>Allow new signups</Label><div className="text-xs text-muted-foreground">Toggle off to freeze new customer registration</div></div>
            <Switch checked={signups} onCheckedChange={(v) => { setSignups(v); toast.success("Preference saved"); }} />
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div><Label>Default interest — Personal</Label><Input defaultValue="14" /></div>
            <div><Label>Default interest — Salary Advance</Label><Input defaultValue="18" /></div>
            <div><Label>Max ticket — Personal</Label><Input defaultValue="500000" /></div>
            <div><Label>Max ticket — Salary Advance</Label><Input defaultValue="100000" /></div>
          </div>
          <Button className="rounded-full brand-gradient text-white" onClick={() => toast.success("Settings saved")}>Save</Button>
        </Card>
      </div>
    </AdminLayout>
  );
}
